import { useHierarchicalMenu, useHits } from 'react-instantsearch';

import type { FunctionComponent } from 'react';
import type { TypeTitleProps } from './types';

/**
 * Title
 */
export const Title: FunctionComponent<TypeTitleProps> = ({
  className = '',
  attributes,
  title,
  defaultArea,
}: TypeTitleProps) => {
  const { results } = useHits();
  const { items } = useHierarchicalMenu({
    attributes,
  });
  const getLastRefined = (items: any): string => {
    const item = items?.filter((item: any) => item.isRefined)[0];

    if (item && item.isRefined) {
      const hasChildrenRefined =
        item?.data?.filter((item: any) => item.isRefined)?.length > 0;

      if (hasChildrenRefined && item?.data) {
        return getLastRefined(item.data);
      } else {
        return item?.value;
      }
    } else {
      return defaultArea;
    }
  };

  return (
    <h1
      className={`text-body text-body-m flex flex-row gap-1 font-normal ${className}`}
    >
      {results?.nbHits}{' '}
      <strong id="list-flats-name">{title(getLastRefined(items))}</strong>
    </h1>
  );
};

Title.displayName = 'Title';
